import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { getPagePartSlug } from '@gov-nx/module/page/definitions/PageMap';
import AuthorizedRoute from '../../routes/AuthorizedRoute';

const ConsentManagementPage = lazy(() =>
	import('./ConsentManagementPage').then(({ ConsentManagementPage }) => ({
		default: ConsentManagementPage,
	}))
);

const ConsentManagementDetailPage = lazy(() =>
	import('./ConsentManagementDetailPage').then(
		({ ConsentManagementDetailPage }) => ({
			default: ConsentManagementDetailPage,
		})
	)
);

export const getConsentManagementRoutes = (): RouteObject[] => [
	{
		path: getPagePartSlug('sprava-souhlasu'),
		children: [
			{
				index: true,
				element: (
					<AuthorizedRoute>
						<ConsentManagementPage />
					</AuthorizedRoute>
				),
			},
			{
				path: getPagePartSlug('sprava-souhlasu.detail'),
				element: (
					<AuthorizedRoute>
						<ConsentManagementDetailPage />
					</AuthorizedRoute>
				),
			},
		],
	},
];
